import * as yup from 'yup';

export const schema = yup.object({
  tipo_classificacao: yup.object().shape({
    label: yup.string().required(),
    value: yup.number().required(),
  }),
  des_classificacao: yup.string().trim().required(),
});
